import Script from 'next/script';
import { useState, useEffect } from 'react';
import { hasAnalyticsConsent } from '@/lib/utils/cookie-consent';

export default function CookieConsentScripts() {
  const [analyticsConsent, setAnalyticsConsent] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setAnalyticsConsent(hasAnalyticsConsent());
    setHydrated(true);
  }, []);

  if (!hydrated || !analyticsConsent) {
    return null;
  }

  return (
    <>
      {/* Trustpilot */}
      <Script
        src="https:////widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
      />
    </>
  );
}
